import fetch from '@/utils/fetch';
import { getParams} from '@/utils/fetch';

//修改活动设置
export function updateAbcActivitySet(args) {

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/abcActivity/updateAbcActivitySet',
        method: 'POST',
        data: JSON.stringify(args)
    });
}
//新增活动设置
export function addAbcActivitySet(args) {

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/abcActivity/addAbcActivitySet',
        method: 'POST',
        data: JSON.stringify(args)
    });
}

//分页查询活动设置列表
export function getAbcActivitySetListPage(args) {
    const params = getParams(true, args);
    params.append('orgAreaCode', args.orgAreaCode);
    params.append('state', args.state);
    params.append('title', args.title);

    return fetch({
        url: 'structure/abcActivity/getAbcActivitySetListPage',
        method: 'get',
        params
    });
}

// 删除活动设置
export function delAbcActivitySet(args) {
    const params = getParams();
    params.append('abcActivitySetId', args.abcActivitySetId);

    return fetch({
        url: 'structure/abcActivity/delAbcActivitySet',
        method: 'get',
        params
    });
}
// 查询活动设置
export function getAbcActivitySet(args) {
    const params = getParams();
    params.append('abcActivitySetId', args.abcActivitySetId);

    return fetch({
        url: 'structure/abcActivity/getAbcActivitySet',
        method: 'get',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/abcActivityManagement.js